import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../core/services/session.service';
import { UtilityService } from '../../core/services/utility.service';
import { Session } from '../../core/models/session';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { NewPageList } from '../../core/models/new-page-list';

@Component({
  selector: 'app-chatroom',
  templateUrl: './chatroom.component.html',
  styleUrls: ['./chatroom.component.css'],
  providers: [SessionService,ExtraService,SessionService]
})
export class ChatroomComponent implements OnInit {
  
  eventId: string = '';
  sessionId: string='';
  displayMessage: string;
  aboutList = new Array<any>();
  session = new Session();
  
  constructor(private extraService:ExtraService,private route: ActivatedRoute,private router:Router,
    private sessionService: SessionService, private utilityService:UtilityService) { }

  ngOnInit() {  
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);

    this.route.params.subscribe(params => { 
      let id = params['eventId']; 
      this.eventId = id;
    });

  }

  receiveSession($event) {
    this.sessionId = $event.sessionId;
    this.setAllMessages(this.sessionId);
  }

  setAllMessages(sessionId: string) {
    this.sessionService.getSingleSessionList(this.eventId, sessionId).subscribe(event=>{
      if(event) {
        
        this.session = event;
        this.displayMessage = 'Sorry "'+this.session.name+'" their is no message to display...';
      }
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/chatroom/chatroom.component.ts